import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from 'components/material-symbol/icons/Close'
import NotificationsOffOutlinedIcon from 'components/material-symbol/icons/NotificationsOff'
import { useState } from 'react'

const MS = {
  hour: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  week: 7 * 24 * 60 * 60 * 1000,
  month: 30 * 24 * 60 * 60 * 1000,
}

const INDEFINITE = 'indefinite'

const MUTE_DURATION_OPTIONS = [
  { label: '1 hour', value: MS.hour },
  { label: '1 day', value: MS.day },
  { label: '1 week', value: MS.week },
  { label: '1 month', value: MS.month },
  { label: '6 months', value: 6 * MS.month },
  { label: 'Until unmuted', value: INDEFINITE },
]

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(3, 3, 2),
    position: 'relative',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
    paddingRight: theme.spacing(5),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  durationField: {
    marginTop: theme.spacing(2),
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 9999,
      backgroundColor: theme.palette.common.white,
      minHeight: 44,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
      borderRadius: 9999,
    },
    '& fieldset': {
      borderRadius: 9999,
    },
    '& .MuiSelect-outlined': {
      padding: theme.spacing(1.25, 1.5),
      fontSize: '0.875rem',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '0.875rem',
    },
  },
}))

function MuteChannelDialog({ open, setOpen, channel, onSuccess }) {
  const classes = useStyles()
  const [selectedDuration, setSelectedDuration] = useState(
    MUTE_DURATION_OPTIONS[0].value,
  )

  const handleConfirm = async () => {
    const options =
      selectedDuration !== INDEFINITE
        ? { expiration: selectedDuration }
        : undefined
    await channel.mute(options)
    onSuccess()
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography className={classes.title}>Mute Conversation</Typography>
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Stop receiving notifications for this conversation for:
        </DialogContentText>
        <TextField
          className={classes.durationField}
          data-testid="mute-duration-select"
          fullWidth
          label="Mute for"
          onChange={e => setSelectedDuration(e.target.value)}
          select
          value={selectedDuration}
          variant="outlined"
        >
          {MUTE_DURATION_OPTIONS.map(option => (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleConfirm}
          startIcon={<NotificationsOffOutlinedIcon />}
        >
          Mute
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MuteChannelDialog
